define('editor/edit/map/controls/legend',['durandal/app', 'knockout', 'jquery', 'leaflet-legend'], function (app, ko, $) {
  var control = function (options) {
    var self = this;

    self.options = options;
    self.layer = options.layer;

    if (!Object.keys(self.layer.state()).length) {
      self.layer.state({
        width: ko.observable(200),
        height: ko.observable(200),
        position: {
          x: ko.observable(0),
          y: ko.observable(0)
        },
        html: ko.observable('<h4>Legend</h4><p>Items here...</p>')
      });
    }

    self.addToMap = function () {
      // use the our custom map pane as a container to attach the control to
      var controlContainer = self.options.mapControl._controlContainer;

      var opts = {
        container: controlContainer,
        viewport: {
          height: self.options.editorMap.height,
          width: self.options.editorMap.width
        }
      };

      $.extend(opts, ko.toJS(self.layer.state()));

      opts.html = self.buildLegendHtml();

      self.control = L.legend(opts);

      if (self.options.visible()) {
        self.show();
      }

      self.registerEventHandlers();
    };

    self.buildLegendHtml = function () {
      var state = ko.toJS(self.layer.state());
      var items = state.items;
      var itemSize = state.itemSize;
      var html = '<h4 class="' + itemSize + '">' + self.layer.name() + '</h4>';
      for (var i = 0; i < items.length; i++) {
        html += '<div class="clearfix legend-item ' + itemSize + '">';

        if (items[i].isIcon) {
          var hasPaddle = items[i].html.indexOf('marker.svg') > -1;
          var hasPaddleAndIcon = items[i].html.split("<svg").length === 3;
          html += '<div class="pull-left legend-icon ';
          
          if (!hasPaddle && !hasPaddleAndIcon) {
              html += 'icon-only';
          }
          
          html += '">';
          if (items[i].isSvg) {
            html += items[i].html;
          } else if (items[i].icon) {
            html += '<img src="' + items[i].icon + '" />';
          }
        } else if (items[i].isPolygon) {
          html += '<div class="pull-left legend-icon">';
          if (items[i].polygonColour) {
            html += '<div class="legend-polygon" style="background-color:' + items[i].polygonColour + '; opacity:' + items[i].polygonOpacity + '">&nbsp;</div>';
          }
        } else if (items[i].isPolyline) {
          html += '<div class="pull-left legend-icon">';
          if (items[i].polylineColour) {
            html += '<div class="legend-polyline" style="background-color:' + items[i].polylineColour + '; opacity:' + items[i].polylineOpacity + '">&nbsp;</div>';
          }
        }
        html += '</div>';
        html += '<div class="media-body">';
        html += items[i].text;
        html += '</div>';
        html += '</div>';
      }
      return html;
    };

    self.registerEventHandlers = function () {
      self.options.mapControl.on('legendMoved', self.handleLegendMoved);
      self.options.mapControl.on('legendResized', self.handleLegendResized);
    };

    self.deregisterEventHandlers = function () {
      self.options.mapControl.off('legendMoved', self.handleLegendMoved);
      self.options.mapControl.off('legendResized', self.handleLegendResized);
    };

    self.allowEdit = function () {
      if (self.layer.visible()) {
        self.control.enableEdit();
      }
    };

    self.preventEdit = function () {
      if (self.layer.visible()) {
        self.control.disableEdit();
      }
    };

    self.hide = function () {
      self.control.remove();
      self.deregisterEventHandlers();
    };

    self.show = function () {
      self.control.addTo(self.options.mapControl);
      self.control._container.style.zIndex = 1000 - self.layer.order();
    };

    self.remove = function () {
      self.hide();
      self.deregisterEventHandlers();
    };

    self.handleLegendMoved = function (e) {
      self.layer.state().position = {
        x: ko.observable(e.x),
        y: ko.observable(e.y)
      };
    };

    self.handleLegendResized = function (e) {
      self.layer.state().width(e.width);
      self.layer.state().height(e.height);
    };
  };

  return control;
});
